module.exports={render:function (){with(this) {
  return _h('span', {
    staticClass: "ion-note"
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a20fc7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/note/src/note.vue
// module id = 155
// module chunks = 0